<template>
  <nav class="nav-sirrus">
    <nav-bar></nav-bar>
    <div class="container">
      <div style="height: 40px"></div>
      <div style="overflow-x: auto;white-space: nowrap;" class=" col s12 navigation" id="mainNav">
        <a v-for="gp in this.$store.state.produtos"
           @click="selecionar('grupo-'+ gp.id)"
           class="btn navigation__link "
           style="margin-right: 5px;"
           :id="'#menugrupo-'+gp.id">{{gp.nome}}</a>
      </div>
    </div>
  </nav>
</template>

<script>
  import NavBar from "./NavBar";
  export default {
    name: "MenuHorizontal",
    components: {NavBar},
    methods:{
      selecionar(grupo){
        var elmnt = document.getElementById(grupo);
        elmnt.scrollIntoView(true);
        window.scrollBy(0, -90);
      }
    }
  }
</script>

<style scoped>
  .page-section { }
  .navigation { }
  .navigation__link { }
  .navigation__link:hover {
    background-color: #26a69a;
    color: white;
  }
  .navigation__link.active {
    color: #118a79;
    background-color: #CDE2DC;
  }
  @media only screen and (min-width: 601px){
    nav, nav .nav-wrapper i, nav a.sidenav-trigger, nav a.sidenav-trigger i {
      height: 40px;
      line-height: 40px;
    }
  }
  @media only screen and (max-device-width: 768px) {
    /* Styles */
    .container {
      margin: 0 auto;
      max-width: 1280px;
      width: 97%;
    }
  }

  .nav-sirrus{
    background-color: white; height: 96px;
  }
</style>



// WEBPACK FOOTER //
// src/app/views/template/MenuHorizontal.vue